import { render, staticRenderFns } from "./AjaxFileUpload.vue?vue&type=template&id=bcd45682&"
import script from "./AjaxFileUpload.vue?vue&type=script&lang=ts&"
export * from "./AjaxFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports